import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import ErrorMessage from './ErrorMessage';

const NestedSelectInput= ({
  name,
  options,
  childrenNestingKey='children',
  parentOptionLabel='label',
  parentOptionValue='value',
  optionLabel='label',
  optionValue='value',
  parentSelectable=false,
  placeholder='',
}) => {
  const { control} = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <div className="mb-3">
          <div className="form-floating">
          <select
            {...field}
            id={field.name}
            className={`form-select form-control ${isTouched && invalid ? "is-invalid" : ""}`}
          >
            <option key="__prompt__">{placeholder}</option>
            {options.map((o) => {
              const opts = [
                <option key={o[parentOptionValue]} className="parent" value={o[parentOptionValue]} disabled={!parentSelectable}>
                  {o[parentOptionLabel]}
                </option>
              ];
              o[childrenNestingKey].forEach((c) =>
                opts.push(
                  <option key={c[optionValue]} className="child" value={c[optionValue]}>
                    {`${o[parentOptionLabel]}: ${c[optionLabel]}`}
                  </option>
                )
              );
              return opts;
            })}
          </select>
            {/* <input
              {...field}
              id={field.name}
              type={type}
              className={`form-control ${isTouched && invalid ? "is-invalid" : ""}`}
              placeholder={placeholder} 
            /> */}
            <label htmlFor={field.name}>{placeholder}</label>
          </div>
          <ErrorMessage error={error}/>
        </div>
      )}
    />
  )
}

// function NestedSelect({
//   options,
//   value,
//   onChange,
//   childrenNestingKey='children',
//   parentOptionLabel='label',
//   parentOptionValue='value',
//   optionLabel='label',
//   optionValue='value',
//   parentSelectable=false,
//   onBlur,
//   placeholder='',
//   id='',
//   className
// }) {
//   return (
//     <select
//       id={id}
//       className={className}
//       value={value}
//       onChange={e => onChange(e.target.value)}
//       onBlur={ onBlur }
//     >
//       <option key="__prompt__">{placeholder}</option>
//       {options.map((o) => {
//         const opts = [
//           <option key={o[parentOptionValue]} className="parent" value={o[parentOptionValue]} disabled={!parentSelectable}>
//             {o[parentOptionLabel]}
//           </option>
//         ];
//         o[childrenNestingKey].forEach((c) =>
//           opts.push(
//             <option key={c[optionValue]} className="child" value={c[optionValue]}>
//               {`${o[parentOptionLabel]}: ${c[optionLabel]}`}
//             </option>
//           )
//         );
//         return opts;
//       })}
//     </select>
//   )
// };

export default NestedSelectInput;